import React from "react";
import * as H from "../../../hooks";
import { RegWizard } from "../../RegDoc";

const Reg: React.FC = () => {
    const [root, mission] = H.useRoots();
    return <RegWizard context={root} mission_id={mission} />;
}

export default Reg;